"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: stock/stock-enrollment-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fstock%2Fstock-enrollment-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.StockEnrollmentServiceClient = exports.confirmEligibilityResponseRequirementTypeToJSON = exports.confirmEligibilityResponseRequirementTypeFromJSON = exports.GetClosedStockAccountsResponse = exports.GetClosedStockAccountsRequest = exports.UpdateEnrollmentDataResponse = exports.UpdateEnrollmentDataRequest = exports.ConfirmEligibilityResponseRequirement = exports.ConfirmEligibilityResponse = exports.ConfirmEligibilityRequest = exports.GetEnrollmentResponse = exports.GetEnrollmentRequest = exports.CreateAccountResponse = exports.CreateAccountRequest = exports.EnrollUserResponse = exports.EnrollUserRequest = exports.ConfirmEligibilityResponseRequirementType = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const stock_1 = require("./stock");
const protobufPackage = 'com.step.stock.proto';
var ConfirmEligibilityResponseRequirementType;
(function (ConfirmEligibilityResponseRequirementType) {
    ConfirmEligibilityResponseRequirementType["INVALID_REQUIREMENT_TYPE"] = "INVALID_REQUIREMENT_TYPE";
    ConfirmEligibilityResponseRequirementType["ADDRESS"] = "ADDRESS";
    ConfirmEligibilityResponseRequirementType["AGE"] = "AGE";
    ConfirmEligibilityResponseRequirementType["AUTHORIZATION"] = "AUTHORIZATION";
    ConfirmEligibilityResponseRequirementType["EMAIL"] = "EMAIL";
    ConfirmEligibilityResponseRequirementType["KYC"] = "KYC";
    ConfirmEligibilityResponseRequirementType["PHONE"] = "PHONE";
    ConfirmEligibilityResponseRequirementType["NAME"] = "NAME";
    ConfirmEligibilityResponseRequirementType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(ConfirmEligibilityResponseRequirementType || (exports.ConfirmEligibilityResponseRequirementType = ConfirmEligibilityResponseRequirementType = {}));
function createBaseEnrollUserRequest() {
    return {
        identification: stock_1.IdentificationData.fromPartial({}),
        personal: undefined,
        employment: stock_1.EmploymentData.fromPartial({}),
        profile: stock_1.InvestorProfileData.fromPartial({}),
    };
}
exports.EnrollUserRequest = {
    fromJSON(object) {
        const message = {
            identification: isSet(object.identification)
                ? stock_1.IdentificationData.fromJSON(object.identification)
                : stock_1.IdentificationData.fromPartial({}),
            employment: isSet(object.employment)
                ? stock_1.EmploymentData.fromJSON(object.employment)
                : stock_1.EmploymentData.fromPartial({}),
            profile: isSet(object.profile)
                ? stock_1.InvestorProfileData.fromJSON(object.profile)
                : stock_1.InvestorProfileData.fromPartial({}),
        };
        if (isSet(object.personal)) {
            message.personal = stock_1.PersonalData.fromJSON(object.personal);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.identification !== undefined) {
            obj.identification = stock_1.IdentificationData.toJSON(message.identification);
        }
        if (message.personal !== undefined) {
            obj.personal = stock_1.PersonalData.toJSON(message.personal);
        }
        if (message.employment !== undefined) {
            obj.employment = stock_1.EmploymentData.toJSON(message.employment);
        }
        if (message.profile !== undefined) {
            obj.profile = stock_1.InvestorProfileData.toJSON(message.profile);
        }
        return obj;
    },
    create(base) {
        return exports.EnrollUserRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEnrollUserRequest();
        message.identification = (object.identification !== undefined && object.identification !== null)
            ? stock_1.IdentificationData.fromPartial(object.identification)
            : stock_1.IdentificationData.fromPartial({});
        message.personal = (object.personal !== undefined && object.personal !== null)
            ? stock_1.PersonalData.fromPartial(object.personal)
            : undefined;
        message.employment = (object.employment !== undefined && object.employment !== null)
            ? stock_1.EmploymentData.fromPartial(object.employment)
            : stock_1.EmploymentData.fromPartial({});
        message.profile = (object.profile !== undefined && object.profile !== null)
            ? stock_1.InvestorProfileData.fromPartial(object.profile)
            : stock_1.InvestorProfileData.fromPartial({});
        return message;
    },
};
function createBaseEnrollUserResponse() {
    return { enrollment: stock_1.Enrollment.fromPartial({}) };
}
exports.EnrollUserResponse = {
    fromJSON(object) {
        const message = {
            enrollment: isSet(object.enrollment)
                ? stock_1.Enrollment.fromJSON(object.enrollment)
                : stock_1.Enrollment.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.enrollment !== undefined) {
            obj.enrollment = stock_1.Enrollment.toJSON(message.enrollment);
        }
        return obj;
    },
    create(base) {
        return exports.EnrollUserResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEnrollUserResponse();
        message.enrollment = (object.enrollment !== undefined && object.enrollment !== null)
            ? stock_1.Enrollment.fromPartial(object.enrollment)
            : stock_1.Enrollment.fromPartial({});
        return message;
    },
};
function createBaseCreateAccountRequest() {
    return {};
}
exports.CreateAccountRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.CreateAccountRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseCreateAccountRequest();
        return message;
    },
};
function createBaseCreateAccountResponse() {
    return { enrollment: stock_1.Enrollment.fromPartial({}) };
}
exports.CreateAccountResponse = {
    fromJSON(object) {
        const message = {
            enrollment: isSet(object.enrollment)
                ? stock_1.Enrollment.fromJSON(object.enrollment)
                : stock_1.Enrollment.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.enrollment !== undefined) {
            obj.enrollment = stock_1.Enrollment.toJSON(message.enrollment);
        }
        return obj;
    },
    create(base) {
        return exports.CreateAccountResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreateAccountResponse();
        message.enrollment = (object.enrollment !== undefined && object.enrollment !== null)
            ? stock_1.Enrollment.fromPartial(object.enrollment)
            : stock_1.Enrollment.fromPartial({});
        return message;
    },
};
function createBaseGetEnrollmentRequest() {
    return {};
}
exports.GetEnrollmentRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetEnrollmentRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetEnrollmentRequest();
        return message;
    },
};
function createBaseGetEnrollmentResponse() {
    return { enrollment: undefined };
}
exports.GetEnrollmentResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.enrollment)) {
            message.enrollment = stock_1.Enrollment.fromJSON(object.enrollment);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.enrollment !== undefined) {
            obj.enrollment = stock_1.Enrollment.toJSON(message.enrollment);
        }
        return obj;
    },
    create(base) {
        return exports.GetEnrollmentResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetEnrollmentResponse();
        message.enrollment = (object.enrollment !== undefined && object.enrollment !== null)
            ? stock_1.Enrollment.fromPartial(object.enrollment)
            : undefined;
        return message;
    },
};
function createBaseConfirmEligibilityRequest() {
    return {};
}
exports.ConfirmEligibilityRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.ConfirmEligibilityRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseConfirmEligibilityRequest();
        return message;
    },
};
function createBaseConfirmEligibilityResponse() {
    return { requirements: [] };
}
exports.ConfirmEligibilityResponse = {
    fromJSON(object) {
        const message = {
            requirements: globalThis.Array.isArray(object?.requirements)
                ? object.requirements.map((e) => exports.ConfirmEligibilityResponseRequirement.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.requirements?.length) {
            obj.requirements = message.requirements.map((e) => exports.ConfirmEligibilityResponseRequirement.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.ConfirmEligibilityResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseConfirmEligibilityResponse();
        message.requirements =
            object.requirements?.map((e) => exports.ConfirmEligibilityResponseRequirement.fromPartial(e)) || [];
        return message;
    },
};
function createBaseConfirmEligibilityResponseRequirement() {
    return {
        confirmed: false,
        type: ConfirmEligibilityResponseRequirementType.INVALID_REQUIREMENT_TYPE,
    };
}
exports.ConfirmEligibilityResponseRequirement = {
    fromJSON(object) {
        const message = {
            confirmed: isSet(object.confirmed) ? globalThis.Boolean(object.confirmed) : false,
            type: isSet(object.type)
                ? confirmEligibilityResponseRequirementTypeFromJSON(object.type)
                : ConfirmEligibilityResponseRequirementType.INVALID_REQUIREMENT_TYPE,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.confirmed !== false) {
            obj.confirmed = message.confirmed;
        }
        if (message.type !== ConfirmEligibilityResponseRequirementType.INVALID_REQUIREMENT_TYPE) {
            obj.type = confirmEligibilityResponseRequirementTypeToJSON(message.type);
        }
        return obj;
    },
    create(base) {
        return exports.ConfirmEligibilityResponseRequirement.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseConfirmEligibilityResponseRequirement();
        message.confirmed = object.confirmed ?? false;
        message.type = object.type ??
            ConfirmEligibilityResponseRequirementType.INVALID_REQUIREMENT_TYPE;
        return message;
    },
};
function createBaseUpdateEnrollmentDataRequest() {
    return {
        identification: stock_1.IdentificationData.fromPartial({}),
        personal: undefined,
        employment: stock_1.EmploymentData.fromPartial({}),
        profile: stock_1.InvestorProfileData.fromPartial({}),
        riskLevel: stock_1.PortfolioRiskLevel.INVALID_RISK_LEVEL,
    };
}
exports.UpdateEnrollmentDataRequest = {
    fromJSON(object) {
        const message = {
            identification: isSet(object.identification)
                ? stock_1.IdentificationData.fromJSON(object.identification)
                : stock_1.IdentificationData.fromPartial({}),
            employment: isSet(object.employment)
                ? stock_1.EmploymentData.fromJSON(object.employment)
                : stock_1.EmploymentData.fromPartial({}),
            profile: isSet(object.profile)
                ? stock_1.InvestorProfileData.fromJSON(object.profile)
                : stock_1.InvestorProfileData.fromPartial({}),
            riskLevel: isSet(object.riskLevel)
                ? (0, stock_1.portfolioRiskLevelFromJSON)(object.riskLevel)
                : stock_1.PortfolioRiskLevel.INVALID_RISK_LEVEL,
        };
        if (isSet(object.personal)) {
            message.personal = stock_1.PersonalData.fromJSON(object.personal);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.identification !== undefined) {
            obj.identification = stock_1.IdentificationData.toJSON(message.identification);
        }
        if (message.personal !== undefined) {
            obj.personal = stock_1.PersonalData.toJSON(message.personal);
        }
        if (message.employment !== undefined) {
            obj.employment = stock_1.EmploymentData.toJSON(message.employment);
        }
        if (message.profile !== undefined) {
            obj.profile = stock_1.InvestorProfileData.toJSON(message.profile);
        }
        if (message.riskLevel !== stock_1.PortfolioRiskLevel.INVALID_RISK_LEVEL) {
            obj.riskLevel = (0, stock_1.portfolioRiskLevelToJSON)(message.riskLevel);
        }
        return obj;
    },
    create(base) {
        return exports.UpdateEnrollmentDataRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateEnrollmentDataRequest();
        message.identification = (object.identification !== undefined && object.identification !== null)
            ? stock_1.IdentificationData.fromPartial(object.identification)
            : stock_1.IdentificationData.fromPartial({});
        message.personal = (object.personal !== undefined && object.personal !== null)
            ? stock_1.PersonalData.fromPartial(object.personal)
            : undefined;
        message.employment = (object.employment !== undefined && object.employment !== null)
            ? stock_1.EmploymentData.fromPartial(object.employment)
            : stock_1.EmploymentData.fromPartial({});
        message.profile = (object.profile !== undefined && object.profile !== null)
            ? stock_1.InvestorProfileData.fromPartial(object.profile)
            : stock_1.InvestorProfileData.fromPartial({});
        message.riskLevel = object.riskLevel ?? stock_1.PortfolioRiskLevel.INVALID_RISK_LEVEL;
        return message;
    },
};
function createBaseUpdateEnrollmentDataResponse() {
    return {};
}
exports.UpdateEnrollmentDataResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.UpdateEnrollmentDataResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseUpdateEnrollmentDataResponse();
        return message;
    },
};
function createBaseGetClosedStockAccountsRequest() {
    return {};
}
exports.GetClosedStockAccountsRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetClosedStockAccountsRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetClosedStockAccountsRequest();
        return message;
    },
};
function createBaseGetClosedStockAccountsResponse() {
    return { accounts: [] };
}
exports.GetClosedStockAccountsResponse = {
    fromJSON(object) {
        const message = {
            accounts: globalThis.Array.isArray(object?.accounts)
                ? object.accounts.map((e) => stock_1.ClosedStockAccount.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.accounts?.length) {
            obj.accounts = message.accounts.map((e) => stock_1.ClosedStockAccount.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetClosedStockAccountsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetClosedStockAccountsResponse();
        message.accounts = object.accounts?.map((e) => stock_1.ClosedStockAccount.fromPartial(e)) || [];
        return message;
    },
};
function confirmEligibilityResponseRequirementTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_REQUIREMENT_TYPE':
            return ConfirmEligibilityResponseRequirementType.INVALID_REQUIREMENT_TYPE;
        case 1:
        case 'ADDRESS':
            return ConfirmEligibilityResponseRequirementType.ADDRESS;
        case 2:
        case 'AGE':
            return ConfirmEligibilityResponseRequirementType.AGE;
        case 3:
        case 'AUTHORIZATION':
            return ConfirmEligibilityResponseRequirementType.AUTHORIZATION;
        case 4:
        case 'EMAIL':
            return ConfirmEligibilityResponseRequirementType.EMAIL;
        case 5:
        case 'KYC':
            return ConfirmEligibilityResponseRequirementType.KYC;
        case 6:
        case 'PHONE':
            return ConfirmEligibilityResponseRequirementType.PHONE;
        case 7:
        case 'NAME':
            return ConfirmEligibilityResponseRequirementType.NAME;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return ConfirmEligibilityResponseRequirementType.UNRECOGNIZED;
    }
}
exports.confirmEligibilityResponseRequirementTypeFromJSON = confirmEligibilityResponseRequirementTypeFromJSON;
function confirmEligibilityResponseRequirementTypeToJSON(object) {
    switch (object) {
        case ConfirmEligibilityResponseRequirementType.INVALID_REQUIREMENT_TYPE:
            return 'INVALID_REQUIREMENT_TYPE';
        case ConfirmEligibilityResponseRequirementType.ADDRESS:
            return 'ADDRESS';
        case ConfirmEligibilityResponseRequirementType.AGE:
            return 'AGE';
        case ConfirmEligibilityResponseRequirementType.AUTHORIZATION:
            return 'AUTHORIZATION';
        case ConfirmEligibilityResponseRequirementType.EMAIL:
            return 'EMAIL';
        case ConfirmEligibilityResponseRequirementType.KYC:
            return 'KYC';
        case ConfirmEligibilityResponseRequirementType.PHONE:
            return 'PHONE';
        case ConfirmEligibilityResponseRequirementType.NAME:
            return 'NAME';
        case ConfirmEligibilityResponseRequirementType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.confirmEligibilityResponseRequirementTypeToJSON = confirmEligibilityResponseRequirementTypeToJSON;
/**
 * Stock Enrollment public API.
 */
class StockEnrollmentServiceClient {
    rpc;
    name = 'com.step.stock.proto.StockEnrollmentService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/stock';
    methods = [{
            name: 'EnrollUser',
            requestType: exports.EnrollUserRequest,
            responseType: exports.EnrollUserResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'CreateAccount',
            requestType: exports.CreateAccountRequest,
            responseType: exports.CreateAccountResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetClosedStockAccounts',
            requestType: exports.GetClosedStockAccountsRequest,
            responseType: exports.GetClosedStockAccountsResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetEnrollment',
            requestType: exports.GetEnrollmentRequest,
            responseType: exports.GetEnrollmentResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'UpdateEnrollmentData',
            requestType: exports.UpdateEnrollmentDataRequest,
            responseType: exports.UpdateEnrollmentDataResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'ConfirmEligibility',
            requestType: exports.ConfirmEligibilityRequest,
            responseType: exports.ConfirmEligibilityResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Enroll user into stocks.
     */
    enrollUser(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Create stock account for user (self OR authorized)
     */
    createAccount(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns a list of closed stock accounts.
     */
    getClosedStockAccounts(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Get stock enrollment status.
     */
    getEnrollment(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Update enrollment data.
     */
    updateEnrollmentData(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[4],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Confirms the user's eligibility status for a stock feature enrollment.
     */
    confirmEligibility(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[5],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.StockEnrollmentServiceClient = StockEnrollmentServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=stock-enrollment-service.js.map